import { Box, Typography } from '@material-ui/core';

type EmptyCellProps = {
  className?: string;
  align?: 'left' | 'center' | 'right';
};

export const EmptyCell = ({ className, align = 'center' }: EmptyCellProps) => (
  <Box display="flex" justifyContent={align}>
    <Typography className={className}>-</Typography>
  </Box>
);
